import { ProblemsTicket } from './ProblemsTicket';
import { IncidentTicket } from './IncidentTicket';
import { AisIncidentTicket } from './AisIncidentTicket';
import { ChangeRecordsTicket } from './ChangeRecordsTicket';
import { RequestForChangesTicket} from './RequestForChangesTicket';
import { ServiceRequestTicket } from './ServiceRequestTicket';
import { TicketStatus } from '../ticket-status/TicketStatus';
import { TicketPriority } from '../ticket-priority/ticket.priority';
import { Injectable } from '@angular/core';

export type TicketType = ProblemsTicket | IncidentTicket | AisIncidentTicket |ChangeRecordsTicket | RequestForChangesTicket | ServiceRequestTicket;
@Injectable()
export class TicketFactory {
  public static ticketTypes: { [key: string]: string };
  public static defaultTemplates: { [key: string]: string };
  public static ticketStatuses: { [key: string]: string } = {};

  public static setTicketTypes(types) {
    this.ticketTypes = types;
    for (const i in types) {
      if (types.hasOwnProperty(i)) {
        TicketFactory.ticketStatuses[types[i]] = `portal/${i}_STATUSES`;
      }
    }
  }

  public static setDefaultTemplates(types) {
    this.defaultTemplates = types;
    for (const i in types) {
      if (types.hasOwnProperty(i)) {
        TicketFactory.defaultTemplates[types[i]] = `portal/${i}`;
      }
    }
  }

  public static getTicketTypes(): { [key: string]: string } {
    return this.ticketTypes;
  }

  public static getTopicId(type) {
    return this.ticketTypes[type];
  }

  public static createTicket(
    fromServerTicket: any,
    statuses?: TicketStatus[],
    priorities?: TicketPriority[]
  ): TicketType {
    switch (fromServerTicket.topic_type) {
      case this.ticketTypes.PROBLEMS:
        return new ProblemsTicket(fromServerTicket, statuses, priorities);
      case this.ticketTypes.INCIDENTS:
        return new IncidentTicket(fromServerTicket, statuses, priorities);
      case this.ticketTypes.AIS_INCIDENTS:
        return new AisIncidentTicket(fromServerTicket, statuses, priorities);
      case this.ticketTypes.CHANGE_RECORDS:
        return new ChangeRecordsTicket(fromServerTicket, statuses, priorities);
      case this.ticketTypes.REQUEST_FOR_CHANGES:
        return new RequestForChangesTicket(fromServerTicket, statuses, priorities);
      case this.ticketTypes.SERVICE_REQUESTS:
        return new ServiceRequestTicket(fromServerTicket, statuses, priorities);
      default:
        return null;
    }
  }
}
